module.exports = __webpack_public_path__ + "static/media/nav_circle.8cc35227.svg";